import Team from "../components/pages/Team.js";
import ProcessSection from "../components/pages/ProcessSection";

/**
 * FrontPage interactions
 *
 * @package AGDS
 * @category Modules
 * @module FrontPage
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class FrontPage {
    /**
     * @param {Object} [options={}]
     */
    constructor(options = {}) {
        this.team = null;
        this.process = null;
    }

    /**
     * Initializes.
     *
     * @returns {void}
     */
    init() {
        // Initialize team section
        this.team = Team.init();

		// Initialize process section
		this.process = ProcessSection.init();
    }
}
